import { Link } from 'react-router-dom';
import { featuredContent } from '@/mocks/home';

export default function FeaturedSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">本周最受欢迎的影视内容，大家都在看</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featuredContent.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[2/3] mb-3">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                {item.badge && (
                  <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                    {item.badge}
                  </span>
                )}
                <div className="absolute bottom-2 left-2 right-2">
                  <div className="flex items-center gap-1 text-background-50/90 text-xs">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                    </div>
                    <span>{item.rating}</span>
                    <span className="mx-1">·</span>
                    <span>{item.subCategory}</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">{item.year} · {item.category}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}